// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

/* Gradient Animation for Hero Text */
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.animate-gradient {
  background-size: 200% 200%;
  animation: gradient 8s ease infinite;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #0f0520;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(to bottom, #a855f7, #ec4899);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(to bottom, #9333ea, #db2777);
}

/* Light Mode Scrollbar */
.light-mode ::-webkit-scrollbar-track {
  background: #f3f4f6;
}

.light-mode ::-webkit-scrollbar-thumb {
  background: linear-gradient(to bottom, #9333ea, #db2777);
}

/* Light Mode Utilities */
.light-mode {
  color-scheme: light;
}

html.light-mode {
  background: white;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n/* Gradient Animation for Hero Text */\n@keyframes gradient {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.animate-gradient {\n  background-size: 200% 200%;\n  animation: gradient 8s ease infinite;\n}\n\n/* Custom Scrollbar */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #0f0520;\n}\n\n::-webkit-scrollbar-thumb {\n  background: linear-gradient(to bottom, #a855f7, #ec4899);\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(to bottom, #9333ea, #db2777);\n}\n\n/* Light Mode Scrollbar */\n.light-mode ::-webkit-scrollbar-track {\n  background: #f3f4f6;\n}\n\n.light-mode ::-webkit-scrollbar-thumb {\n  background: linear-gradient(to bottom, #9333ea, #db2777);\n}\n\n/* Light Mode Utilities */\n.light-mode {\n  color-scheme: light;\n}\n\nhtml.light-mode {\n  background: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
